import { glass, LandingSection, Reveal } from "@/components/landing/reveal";
import { MISSION_STAGES } from "@/lib/workflow";

export function LandingStages() {
  return (
    <LandingSection
      id="stages"
      eyebrow="Mission stages"
      title="Guide → Track. One rail."
      lede="The same stages as the product chrome: guided hardware from first upload through issues and release — Guide · Setup · Spec · Design · Verify · Review · Track on the board, not in a wiki. Scheme, Sim, and Firmware stay soft — off this rail for now."
    >
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {MISSION_STAGES.map((stage, i) => (
          <Reveal key={stage.id} delay={0.04 * i}>
            <article className={`${glass} h-full p-5`}>
              <p className="mb-3 font-mono text-[11px] tracking-[0.12em] text-falcon">
                {stage.num || "·"}
              </p>
              <h3 className="mb-2 text-[16px] font-semibold text-white">{stage.title}</h3>
              <p className="m-0 text-[13px] leading-[1.5] text-white/62">{stage.desc}</p>
            </article>
          </Reveal>
        ))}
      </div>
    </LandingSection>
  );
}
